import React from "react";

interface SyncStatusBadgeProps {
  status: "created" | "updated" | "skipped" | "error";
}

const STATUS_COLORS: Record<string, string> = {
  created: "bg-green-100 text-green-800",
  updated: "bg-blue-100 text-blue-800",
  skipped: "bg-yellow-100 text-yellow-800",
  error: "bg-red-100 text-red-800",
};

const SyncStatusBadge: React.FC<SyncStatusBadgeProps> = ({ status }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
      STATUS_COLORS[status] ||
      "bg-gray-100 text-gray-800 dark:bg-rp-surface-raised dark:text-rp-grey"
    }`}
  >
    {status}
  </span>
);

export default SyncStatusBadge;
